module.exports = __webpack_public_path__ + "img/icon_spotify.902b8d436ba26b7086d600eeaa6c2c23.svg";